import { BadgeWidget, Tooltip } from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../../gen-src/Localize';

export function DraftTag(props: { disableTooltip?: boolean }): JSX.Element {
  const badge = <BadgeWidget
    kind={'primary'}
    testId={`draft-tag`}>
    {Messages.draftTag()}
  </BadgeWidget>;

  return !props.disableTooltip ? (
    <Tooltip getContent={() => <div>{Messages.draftTagTooltip()}</div>} maxWidth={200}>
      {badge}
    </Tooltip>
  ) : badge;
}
